import React from 'react';
import Layout from '../../components/Layout';
import messages from '../../locale/jsonMessages';

const isAdmin = false;

export default async function action({ intl }) {

  const title = intl?.formatMessage(messages.adminTabTitle);

  if (!isAdmin) {
    return { redirect: '/login' };
  }

  const Admin = await require.ensure([], require => require('./Admin').default, 'admin');

  return {
    title,
    chunk: 'admin',
    component: <Layout><Admin title={title} /></Layout>,
  };
};
